import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "30",
  fill: "white",
  "fill-opacity": "0.01"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.125 10.3203C5.125 10.2209 5.16451 10.1255 5.23483 10.0551C5.30516 9.98482 5.40054 9.94531 5.5 9.94531H14.5C14.5995 9.94531 14.6948 9.98482 14.7652 10.0551C14.8355 10.1255 14.875 10.2209 14.875 10.3203V11.8203C14.875 11.9128 14.8408 12.002 14.779 12.0708L11.5 15.7143V19.3203C11.4999 19.399 11.4751 19.4756 11.4291 19.5394C11.3831 19.6032 11.3181 19.651 11.2435 19.6758L8.9935 20.4258C8.93716 20.4446 8.87716 20.4497 8.81845 20.4407C8.75974 20.4318 8.704 20.409 8.65581 20.3743C8.60763 20.3396 8.56837 20.2939 8.54128 20.2411C8.51419 20.1882 8.50005 20.1297 8.5 20.0703V15.7143L5.221 12.0708C5.15921 12.002 5.12502 11.9128 5.125 11.8203V10.3203Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "p-2 overflow-y-auto font-normal max-h-72" }
const _hoisted_6 = { class: "mt-2 space-y-2" }
const _hoisted_7 = ["onChange", "value"]
const _hoisted_8 = {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { class: "flex items-center justify-between px-2 py-2 border-gray-300 border-y" }

import api from "@/api/api";
import { debounce } from "@/utils/debounce";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSubOrgTableHeader',
  emits: ["change", "reset", "close"],
  setup(__props, { emit }) {

const isModalOpen = ref(false);
const selectedFilter = ref("");



const button = ref();
const dropdown = ref();

const query = ref("");
const results = ref([] as Array<any>);

function toggleDropdown() {
  setPosition();

  isModalOpen.value = !isModalOpen.value;

  if (dropdown.value.classList.contains("hidden")) {
    dropdown.value.classList.remove("hidden");
  } else {
    dropdown.value.classList.add("hidden");
  }
}

function setPosition() {
  const buttonRect = button.value.getBoundingClientRect();

  if (buttonRect.left > 1000) {
    dropdown.value.classList.remove("left-0");
    dropdown.value.classList.add("right-0");
  } else {
    dropdown.value.classList.remove("right-0");
    dropdown.value.classList.add("left-0");
  }
}

function resetFilters() {
  emit("reset");
  isModalOpen.value = false;
}

const debouncedFetchResults = debounce(async () => {
  if (query.value === "") {
    results.value = [];
    return;
  }

  results.value = (await api.users.searchSubOrganisations(query.value)).data.organisations;
}, 300);

function search() {
  debouncedFetchResults();
}

watch(selectedFilter, () => {
  if (selectedFilter.value) {
    emit("change", "sub_organisation", selectedFilter.value);
    isModalOpen.value = !isModalOpen.value;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: toggleDropdown,
      ref_key: "button",
      ref: button
    }, [
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "30",
        viewBox: "0 0 20 30",
        fill: "currentColor",
        class: _normalizeClass([isModalOpen.value ? 'text-blue-500' : 'text-black', 'w-8 h-8 hover:text-blue-500'])
      }, _hoisted_3, 2))
    ], 512),
    _createElementVNode("div", {
      class: "absolute z-50 bg-white min-w-[244px] w-fit h-fit max-h-96 top-12 border shadow-md hidden",
      ref_key: "dropdown",
      ref: dropdown
    }, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "w-full h-10 px-2 text-base border border-gray-600",
          placeholder: _ctx.$t('search-by-sub-organisation'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          onInput: search
        }, null, 40, _hoisted_4), [
          [_vModelText, query.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "block space-x-2 whitespace-nowrap",
              key: index
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                onChange: ($event: any) => (selectedFilter.value = result),
                value: result,
                class: "rounded hover:cursor-pointer"
              }, null, 40, _hoisted_7),
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(result), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          onClick: resetFilters,
          class: "h-10 font-normal text-red-500"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("reset")), 1)
        ])
      ])
    ], 512)
  ], 64))
}
}

})